export default "__VITE_ASSET__a6ddcf94__"